import React from 'react';
import {useSelector} from 'react-redux';
import DetailsView from './DetailsView';
import authenticationService from '../../../services/authentication/AuthenticationService';
import UploadLogoModal from './uploadLogoModal';
import {LOGO_UPDATED_LOCAL_STORAGE_KEY} from '../../../utils/organisation';

function DetailsContainer() {
  const [isLogoModalOpen, setIsLogoModalOpen] = React.useState(false);
  const [showLogoUploadButton, setShowLogoUploadButton] = React.useState(false);
  const isManager = authenticationService.roles().isManager();
  const organisation = useSelector(state => state.organisation);

  const handleSwitchUploadLogoModal = () => {
    if (isManager) {
      setIsLogoModalOpen(!isLogoModalOpen);
    }
  };

  const handleUploadLogoSuccess = () => {
    handleSwitchUploadLogoModal();
    let logosUpdated = localStorage.getItem(LOGO_UPDATED_LOCAL_STORAGE_KEY);
    logosUpdated = logosUpdated ? JSON.parse(logosUpdated) : {};

    logosUpdated[String(organisation.organisationId)] = (new Date()).toISOString();
    localStorage.setItem(LOGO_UPDATED_LOCAL_STORAGE_KEY, JSON.stringify(logosUpdated));
    window.location.reload();
  };

  return (
    <>
      <DetailsView
        organisation={organisation}
        onShowUploadButton={() => setShowLogoUploadButton(!showLogoUploadButton)}
        onSwitchUploadLogoModal={handleSwitchUploadLogoModal}
        showLogoUploadButton={showLogoUploadButton}
      />
      {isLogoModalOpen &&
        <UploadLogoModal
          organisationId={organisation.organisationId}
          onClose={handleSwitchUploadLogoModal}
          onSubmitSuccess={handleUploadLogoSuccess}
          modalUploadIsOpen={isLogoModalOpen}
        />
      }
    </>
  );
}

export default DetailsContainer;
